import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    motivo: '',
    mensagem: ''
  });

  const countersRef = useRef<HTMLDivElement>(null);
  const [countersAnimated, setCountersAnimated] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const testimonialsRef = useRef<HTMLDivElement>(null);
  const [testimonialsVisible, setTestimonialsVisible] = useState(false);
  const [showTaxInfoModal, setShowTaxInfoModal] = useState(false);
  const [showTaxExtensionModal, setShowTaxExtensionModal] = useState(false);
  const [showItinModal, setShowItinModal] = useState(false);
  const [showBusinessTaxModal, setShowBusinessTaxModal] = useState(false);
  const [showConsultingModal, setShowConsultingModal] = useState(false);
  const [showNotaryModal, setShowNotaryModal] = useState(false);
  const [showPassportModal, setShowPassportModal] = useState(false);
  const [showBookkeepingModal, setShowBookkeepingModal] = useState(false);
  const [showPayrollModal, setShowPayrollModal] = useState(false);
  const [showBusinessConsultingModal, setShowBusinessConsultingModal] = useState(false);
  const [showSelfEmployedModal, setShowSelfEmployedModal] = useState(false);
  const [showRegularizationModal, setShowRegularizationModal] = useState(false);
  const [showIrsNoticesModal, setShowIrsNoticesModal] = useState(false);
  const [show1099Modal, setShow1099Modal] = useState(false);

  const currentLang = i18n.language;

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const testimonials = [
    {
      name: 'Mariana Fournier',
      text: 'Segundo ano que faço minhas taxas com a Amiraco e não troco por nada! Atenciosos, profissionais e atendimento com excelência! Super recomendo! Denise é excepcional!',
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'Leandro Lima',
      text: 'Já faz mais de 6 anos que fazemos as taxas com a Denise/Victor. São muito corretos e organizados. O atendimento prévio pelo WhatsApp também é nota 10. 👍 Recomendo!',
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'Gilberto Venancio',
      text: '6 anos de satisfação, excelente equipe, rápidos e precisos. Pessoas de total confiança, íntegros.',
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'T. F.',
      text: "I've been really happy with AMIRACO Tax Service. Victor makes the whole process easy and stress-free. He's honest, understanding, and takes the time to explain everything clearly. Highly recommend!",
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'Alex Fernandes',
      text: 'Faço minha declaração de imposto de renda com a Denise há 7 anos. Ela é sempre muito profissional e confiável imensamente no trabalho dela.',
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'Douglas Cintra',
      text: 'The best Tax service that ive experience, very polite and efficient.',
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'Clarissa Bioichi',
      text: "Victor has been our go to person for taxes for couple of years now. We always recommend him to our friends. It's a plus that he speaks Portuguese fluently. Thanks Victor and team for the great job and your usual partnership",
      rating: 5,
      service: 'Tax Return',
      image: ''
    },
    {
      name: 'plus bnb',
      text: "I highly recommend Amiraco Tax Service, which has been essential for both my company, Plus BNB Solutions, and my personal finances. The team demonstrates a high level of professionalism, reliability, and efficiency. Whenever I needed support, I was assisted quickly and accurately, making the entire accounting process smooth and secure. Additionally, their clear communication and impeccable technical knowledge make a significant difference. If you're looking for a trustworthy, fast, and high-quality accounting service, I strongly recommend Amiraco Tax Service. I truly appreciate the excellent work they provide!",
      rating: 5,
      service: 'Tax Return + Consultoria Empresarial',
      image: ''
    },
    {
      name: 'A Massimo Alessandri',
      text: 'Há anos tenho usado os serviços da AMIRACO, não apenas para fazer as taxes mas também nas estratégias empresariais. qual melhor formato tributário adequado ao business, com eles me sinto muito seguro nas diretrizes tomadas. vale cada centavo, recomendo 100%!!!',
      rating: 5,
      service: 'Tax Return + Consultoria Empresarial',
      image: ''
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTestimonialsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (testimonialsRef.current) {
      observer.observe(testimonialsRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !countersAnimated) {
            setCountersAnimated(true);
            animateCounters();
          }
        });
      },
      { threshold: 0.5 }
    );
    if (countersRef.current) {
      observer.observe(countersRef.current);
    }
    return () => observer.disconnect();
  }, [countersAnimated]);

  const animateCounters = () => {
    const duration = 2000;
    const frameRate = 1000 / 60;
    const totalFrames = Math.round(duration / frameRate);
    const counters = [
      { id: 'counter1', target: 8500 },
      { id: 'counter2', target: 660 }
    ];
    counters.forEach(({ id, target }) => {
      let frame = 0;
      const increment = target / totalFrames;
      const timer = setInterval(() => {
        frame++;
        const value = Math.min(Math.round(increment * frame), target);
        const element = document.getElementById(id);
        if (element) {
          element.textContent = value.toLocaleString('pt-BR');
        }
        if (frame === totalFrames) {
          clearInterval(timer);
        }
      }, frameRate);
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.nome || !formData.telefone || !formData.email || !formData.mensagem) {
      return;
    }
    if (formData.mensagem.length > 500) {
      return;
    }
    setFormStatus('sending');
    try {
      const formBody = new URLSearchParams();
      formBody.append('nome', formData.nome);
      formBody.append('telefone', formData.telefone);
      formBody.append('email', formData.email);
      formBody.append('motivo', formData.motivo);
      formBody.append('mensagem', formData.mensagem);
      const response = await fetch('https://readdy.ai/api/form/d641s7qbdoed7v0v8veg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });
      if (response.ok) {
        setFormStatus('success');
        setFormData({ nome: '', telefone: '', email: '', motivo: '', mensagem: '' });
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`}>
        <nav className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/2b149d9c0dcc0f774da5ab5b579eeb2d.jpeg" alt="Amiraco Tax Service" className={`h-12 w-auto transition-all duration-300 ${scrolled ? '' : 'brightness-0 invert'}`} />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('inicio')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.home')}</button>
            <button onClick={() => scrollToSection('especialidades')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.specialties')}</button>
            <button onClick={() => scrollToSection('sobre')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.about')}</button>
            <button onClick={() => scrollToSection('time')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.team')}</button>
            <button onClick={() => scrollToSection('certificacoes')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{currentLang === 'pt' ? 'Certificações' : 'Certifications'}</button>
            <button onClick={() => scrollToSection('blog')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.blog')}</button>
            <button onClick={() => scrollToSection('contato')} className={`${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'} transition-colors font-medium cursor-pointer`}>{t('nav.contact')}</button>

            <div className={`flex items-center gap-3 border-l ${scrolled ? 'border-gray-200' : 'border-white/20'} pl-6`}>
              {/* Language Switcher */}
              <button 
                onClick={() => changeLanguage('en')} 
                className={`w-8 h-8 flex items-center justify-center rounded-full overflow-hidden transition-all cursor-pointer ${currentLang === 'en' ? 'ring-2 ring-blue-500 ring-offset-2' : 'opacity-60 hover:opacity-100'}`}
                title="English"
              >
                <img src="https://flagcdn.com/w40/us.png" alt="English" className="w-full h-full object-cover" />
              </button>
              <button 
                onClick={() => changeLanguage('pt')} 
                className={`w-8 h-8 flex items-center justify-center rounded-full overflow-hidden transition-all cursor-pointer ${currentLang === 'pt' ? 'ring-2 ring-blue-500 ring-offset-2' : 'opacity-60 hover:opacity-100'}`}
                title="Português"
              >
                <img src="https://flagcdn.com/w40/br.png" alt="Português" className="w-full h-full object-cover" />
              </button>
              
              {/* Social icons - always visible */}
              <a href="https://www.facebook.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center rounded-full ${scrolled ? 'bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600' : 'bg-white/20 hover:bg-white/30 text-white'} transition-all cursor-pointer`}>
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className={`w-9 h-9 flex items-center justify-center rounded-full ${scrolled ? 'bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600' : 'bg-white/20 hover:bg-white/30 text-white'} transition-all cursor-pointer`}>
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
            <a href="https://wa.me/14153353243" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 hover:scale-105 transition-all shadow-md whitespace-nowrap cursor-pointer">
              {t('nav.schedule')}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMenuOpen(!menuOpen)} className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}>
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </nav>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="container mx-auto px-6 py-4 flex flex-col space-y-4">
              <button onClick={() => scrollToSection('inicio')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.home')}</button>
              <button onClick={() => scrollToSection('especialidades')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.specialties')}</button>
              <button onClick={() => scrollToSection('sobre')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.about')}</button>
              <button onClick={() => scrollToSection('time')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.team')}</button>
              <button onClick={() => scrollToSection('certificacoes')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{currentLang === 'pt' ? 'Certificações' : 'Certifications'}</button>
              <button onClick={() => scrollToSection('blog')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.blog')}</button>
              <button onClick={() => scrollToSection('contato')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer">{t('nav.contact')}</button>

              {/* Language Switcher Mobile */}
              <div className="flex items-center gap-3 pt-2 border-t border-gray-200">
                <span className="text-gray-500 text-sm mr-2">Idioma:</span>
                <button 
                  onClick={() => changeLanguage('en')} 
                  className={`w-8 h-8 flex items-center justify-center rounded-full overflow-hidden transition-all cursor-pointer ${currentLang === 'en' ? 'ring-2 ring-blue-500 ring-offset-2' : 'opacity-60 hover:opacity-100'}`}
                >
                  <img src="https://flagcdn.com/w40/us.png" alt="English" className="w-full h-full object-cover" />
                </button>
                <button 
                  onClick={() => changeLanguage('pt')} 
                  className={`w-8 h-8 flex items-center justify-center rounded-full overflow-hidden transition-all cursor-pointer ${currentLang === 'pt' ? 'ring-2 ring-blue-500 ring-offset-2' : 'opacity-60 hover:opacity-100'}`}
                >
                  <img src="https://flagcdn.com/w40/br.png" alt="Português" className="w-full h-full object-cover" />
                </button>
              </div>

              <div className="flex items-center gap-3 pt-2 border-t border-gray-200">
                <a href="https://www.facebook.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600 transition-all cursor-pointer"><i className="ri-facebook-fill text-lg"></i></a>
                <a href="https://www.instagram.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600 transition-all cursor-pointer"><i className="ri-instagram-line text-lg"></i></a>
              </div>
              <a href="https://wa.me/14153353243" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors text-center whitespace-nowrap cursor-pointer">
                {t('hero.cta')}
              </a>
            </div>
          </div>
        )}
      </header>

      {/* ===== 1. HERO SECTION - NEW DESIGN ===== */}
      <section id="inicio" className="relative overflow-hidden" style={{
        background: 'radial-gradient(900px 500px at 15% 15%, rgba(26,99,214,.14), transparent 60%), radial-gradient(700px 420px at 85% 30%, rgba(20,74,160,.12), transparent 60%), linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)',
        padding: '120px 24px 80px'
      }}>
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative hidden lg:block order-1">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/e96233dd172d86fb551eea4e4340a010.png" 
                  alt="Form 1040 U.S. Individual Income Tax Return" 
                  className="w-full h-auto object-cover"
                  loading="eager"
                />
                {/* Blue Overlay for color harmony */}
                <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/10 via-transparent to-sky-400/10 pointer-events-none"></div>
              </div>
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full">
                    <i className="ri-calendar-check-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-3xl font-bold text-gray-900">+11</span>
                      <span className="text-lg font-semibold text-gray-700">{currentLang === 'pt' ? 'anos' : 'years'}</span>
                    </div>
                    <p className="text-gray-500 text-sm">{currentLang === 'pt' ? 'de experiência' : 'of experience'}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8 order-2">
              {/* Main Title */}
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                {currentLang === 'pt' 
                  ? 'Consultoria Fiscal e Empresarial nos EUA, Feita com Excelência.' 
                  : 'Your US Tax Return, Done with Precision.'}
              </h1>

              {/* Subtitle */}
              <p className="text-xl text-gray-600 leading-relaxed">
                {currentLang === 'pt'
                  ? 'Especialistas em Tax Return, ITIN, abertura de empresas e contabilidade para residentes nos Estados Unidos. Atendimento profissional, organizado e com total conformidade com o IRS.'
                  : 'Experts in Tax Return, ITIN, company formation and accounting for US residents. Professional, organized service with full IRS compliance.'}
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="https://wa.me/14153353243" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-blue-700 hover:scale-105 transition-all shadow-lg whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 w-full sm:flex-1"
                >
                  <i className="ri-calendar-check-line text-xl"></i>
                  {currentLang === 'pt' ? 'Agendar Consulta' : 'Schedule Consultation'}
                </a>
                <a 
                  href="https://amiracotax.taxdome.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-blue-700 hover:scale-105 transition-all shadow-lg whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 w-full sm:flex-1"
                >
                  <i className="ri-login-box-line text-xl"></i>
                  {currentLang === 'pt' ? 'Acesse o Portal' : 'Access Portal'}
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===== 2. O QUE FAZEMOS (Especialidades) ===== */}
      <section id="especialidades" className="py-24 px-6 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 text-sm font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-briefcase-line text-lg"></i>
              {currentLang === 'pt' ? 'O Que Fazemos' : 'What We Do'}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('specialties.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('specialties.description')}
            </p>
          </div>

          {/* Serviços para Pessoa Física */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('specialties.individual')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div 
                onClick={() => setShowTaxInfoModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-file-text-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.taxReturn.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.taxReturn.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowTaxExtensionModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-calendar-check-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.taxExtension.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.taxExtension.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowItinModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-shield-check-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.itin.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.itin.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowConsultingModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-lightbulb-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.consulting.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.consulting.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowNotaryModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-file-shield-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.notary.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.notary.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowPassportModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-8 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mb-6 mx-auto">
                  <i className="ri-passport-line text-3xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">{t('specialties.passport.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.passport.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Serviços para Empresas */}
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('specialties.business')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div 
                onClick={() => setShowBusinessTaxModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-file-text-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">Tax Return {currentLang === 'pt' ? 'Pessoa Jurídica' : 'Business'}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{currentLang === 'pt' ? 'Declaração de imposto para empresas (LLC, S-Corp, C-Corp, Partnership)' : 'Tax return for businesses (LLC, S-Corp, C-Corp, Partnership)'}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowBookkeepingModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-calculator-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.bookkeeping.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.bookkeeping.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowPayrollModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-team-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.payroll.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.payroll.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowBusinessConsultingModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-line-chart-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.businessConsulting.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.businessConsulting.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowSelfEmployedModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-briefcase-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.selfEmployed.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.selfEmployed.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowRegularizationModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-file-shield-2-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.regularization.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.regularization.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShowIrsNoticesModal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-mail-check-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.irsNotices.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.irsNotices.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
              <div 
                onClick={() => setShow1099Modal(true)}
                className="bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-lg p-6 hover:shadow-xl hover:-translate-y-2 transition-all cursor-pointer border border-blue-100/50"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mb-5 mx-auto">
                  <i className="ri-file-list-3-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{t('specialties.1099.title')}</h4>
                <p className="text-gray-600 text-center leading-relaxed text-sm">{t('specialties.1099.desc')}</p>
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold">
                    <i className="ri-information-line"></i>
                    {currentLang === 'pt' ? 'Clique para saber mais' : 'Click to learn more'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal: Bookkeeping (Contabilidade Mensal) */}
      {showBookkeepingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowBookkeepingModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-emerald-600 to-emerald-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-calculator-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Bookkeeping (Contabilidade Mensal)' : 'Bookkeeping (Monthly Accounting)'}</h3>
                  <p className="text-emerald-100 text-sm">{currentLang === 'pt' ? 'Mantenha suas finanças organizadas' : 'Keep your finances organized'}</p>
                </div>
              </div>
              <button onClick={() => setShowBookkeepingModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg">
                    <i className="ri-question-line text-xl text-emerald-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Bookkeeping?' : 'What is Bookkeeping?'}
                  </h4>
                </div>
                <div className="bg-emerald-50 rounded-xl p-6 border border-emerald-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Bookkeeping é o registro organizado e sistemático de todas as transações financeiras da sua empresa. Mantemos seus livros contábeis atualizados mensalmente, garantindo que você tenha controle total sobre receitas, despesas e fluxo de caixa.'
                      : 'Bookkeeping is the organized and systematic recording of all your business financial transactions. We keep your accounting books updated monthly, ensuring you have full control over income, expenses, and cash flow.'}
                  </p>
                </div>
              </div>

              {/* O que inclui */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-checkbox-circle-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Inclui o Serviço?' : 'What Does the Service Include?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Registro de todas as receitas e despesas'
                          : 'Recording of all income and expenses'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Reconciliação bancária mensal'
                          : 'Monthly bank reconciliation'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Categorização de transações'
                          : 'Transaction categorization'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Relatórios financeiros mensais (P&L, Balance Sheet)'
                          : 'Monthly financial reports (P&L, Balance Sheet)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Controle de contas a pagar e receber'
                          : 'Accounts payable and receivable management'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-emerald-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preparação para Tax Return anual'
                          : 'Preparation for annual Tax Return'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Benefícios */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-star-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Benefícios' : 'Benefits'}
                  </h4>
                </div>
                <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Visão clara da saúde financeira do seu negócio'
                          : 'Clear view of your business financial health'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Facilita a declaração de impostos e reduz custos'
                          : 'Facilitates tax filing and reduces costs'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Evita surpresas e multas do IRS'
                          : 'Avoids surprises and IRS penalties'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Ajuda na tomada de decisões estratégicas'
                          : 'Helps in strategic decision making'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calculator-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa de Bookkeeping?' : 'Need Bookkeeping?'}
                </h4>
                <p className="text-emerald-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Mantenha sua contabilidade em dia e foque no crescimento do seu negócio'
                    : 'Keep your accounting up to date and focus on growing your business'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Payroll (Folha de Pagamento) */}
      {showPayrollModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowPayrollModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-violet-600 to-violet-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-team-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Payroll (Folha de Pagamento)' : 'Payroll (Payroll Management)'}</h3>
                  <p className="text-violet-100 text-sm">{currentLang === 'pt' ? 'Gestão completa de folha de pagamento' : 'Complete payroll management'}</p>
                </div>
              </div>
              <button onClick={() => setShowPayrollModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-violet-100 rounded-lg">
                    <i className="ri-question-line text-xl text-violet-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Payroll?' : 'What is Payroll?'}
                  </h4>
                </div>
                <div className="bg-violet-50 rounded-xl p-6 border border-violet-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Payroll é o serviço completo de gestão de folha de pagamento, incluindo cálculo de salários, impostos, benefícios e emissão de W-2. Garantimos que seus funcionários sejam pagos corretamente e que todos os impostos sejam recolhidos em dia.'
                      : 'Payroll is the complete payroll management service, including calculation of salaries, taxes, benefits, and W-2 issuance. We ensure your employees are paid correctly and all taxes are collected on time.'}
                  </p>
                </div>
              </div>

              {/* O que inclui */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-checkbox-circle-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Inclui o Serviço?' : 'What Does the Service Include?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Cálculo de salários e horas trabalhadas'
                          : 'Calculation of salaries and hours worked'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Retenção e pagamento de impostos (Federal, State, FICA)'
                          : 'Tax withholding and payment (Federal, State, FICA)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Emissão de contracheques (paystubs)'
                          : 'Issuance of paystubs'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Depósito direto em conta bancária'
                          : 'Direct deposit to bank account'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Declarações trimestrais (Form 941)'
                          : 'Quarterly filings (Form 941)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-violet-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Emissão de W-2 e W-3 no final do ano'
                          : 'W-2 and W-3 issuance at year-end'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Benefícios */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-star-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Benefícios' : 'Benefits'}
                  </h4>
                </div>
                <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Conformidade total com leis trabalhistas e fiscais'
                          : 'Full compliance with labor and tax laws'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Evita multas e penalidades por atrasos'
                          : 'Avoids fines and penalties for delays'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Economiza tempo e reduz erros'
                          : 'Saves time and reduces errors'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Funcionários satisfeitos com pagamentos pontuais'
                          : 'Satisfied employees with timely payments'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-violet-600 to-violet-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa de Payroll?' : 'Need Payroll?'}
                </h4>
                <p className="text-violet-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Deixe a gestão de folha de pagamento conosco e foque no seu negócio'
                    : 'Leave payroll management to us and focus on your business'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Consultoria Fiscal Empresarial */}
      {showBusinessConsultingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowBusinessConsultingModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-teal-500 to-teal-600 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-line-chart-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Consultoria Fiscal Empresarial' : 'Business Tax Consulting'}</h3>
                  <p className="text-teal-100 text-sm">{currentLang === 'pt' ? 'Estratégias fiscais para empresas' : 'Tax strategies for businesses'}</p>
                </div>
              </div>
              <button onClick={() => setShowBusinessConsultingModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-question-line text-xl text-teal-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Consultoria Fiscal Empresarial?' : 'What is Business Tax Consulting?'}
                  </h4>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Consultoria especializada para empresas que buscam otimizar sua estrutura tributária, reduzir impostos legalmente e tomar decisões estratégicas baseadas em planejamento fiscal inteligente.'
                      : 'Specialized consulting for businesses seeking to optimize their tax structure, legally reduce taxes, and make strategic decisions based on smart tax planning.'}
                  </p>
                </div>
              </div>

              {/* Quando Contratar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-calendar-check-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Contratar?' : 'When to Hire?'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Abertura de nova empresa ou mudança de estrutura (LLC para S-Corp, etc.)'
                          : 'Opening a new business or changing structure (LLC to S-Corp, etc.)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Crescimento significativo da empresa'
                          : 'Significant business growth'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Expansão para outros estados ou países'
                          : 'Expansion to other states or countries'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Compra ou venda de negócio'
                          : 'Buying or selling a business'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Planejamento de sucessão empresarial'
                          : 'Business succession planning'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* O que inclui */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-checkbox-circle-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Inclui?' : 'What Does it Include?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Análise da estrutura tributária atual'
                          : 'Analysis of current tax structure'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Recomendação de melhor estrutura empresarial'
                          : 'Recommendation of best business structure'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Estratégias de redução de impostos'
                          : 'Tax reduction strategies'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Planejamento de distribuição de lucros'
                          : 'Profit distribution planning'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Projeções fiscais e análise de cenários'
                          : 'Tax projections and scenario analysis'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-teal-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Suporte em auditorias e notificações do IRS'
                          : 'Support in IRS audits and notices'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-line-chart-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Otimize os Impostos da Sua Empresa' : 'Optimize Your Business Taxes'}
                </h4>
                <p className="text-teal-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Reduza impostos legalmente e tome decisões estratégicas com nossa consultoria especializada'
                    : 'Legally reduce taxes and make strategic decisions with our specialized consulting'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Organização Fiscal para Autônomos */}
      {showSelfEmployedModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowSelfEmployedModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-amber-600 to-amber-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-briefcase-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Organização Fiscal para Autônomos' : 'Tax Organization for Self-Employed'}</h3>
                  <p className="text-amber-100 text-sm">{currentLang === 'pt' ? 'Controle fiscal para profissionais independentes' : 'Tax control for independent professionals'}</p>
                </div>
              </div>
              <button onClick={() => setShowSelfEmployedModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-question-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Para Quem é Este Serviço?' : 'Who is This Service For?'}
                  </h4>
                </div>
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    {currentLang === 'pt' 
                      ? 'Serviço especializado para profissionais autônomos, freelancers e contractors que recebem 1099 e precisam organizar suas finanças para declarar impostos corretamente e maximizar deduções.'
                      : 'Specialized service for self-employed professionals, freelancers, and contractors who receive 1099 and need to organize their finances to file taxes correctly and maximize deductions.'}
                  </p>
                  <p className="text-gray-600 text-sm">
                    {currentLang === 'pt'
                      ? 'Ideal para: Uber/Lyft drivers, DoorDash/Instacart, consultores, designers, fotógrafos, tradutores, e outros profissionais independentes.'
                      : 'Ideal for: Uber/Lyft drivers, DoorDash/Instacart, consultants, designers, photographers, translators, and other independent professionals.'}
                  </p>
                </div>
              </div>

              {/* O que inclui */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-checkbox-circle-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Inclui?' : 'What Does it Include?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Organização de receitas e despesas'
                          : 'Organization of income and expenses'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Identificação de deduções fiscais'
                          : 'Identification of tax deductions'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Cálculo de estimated taxes trimestrais'
                          : 'Calculation of quarterly estimated taxes'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preparação de Schedule C'
                          : 'Schedule C preparation'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Orientação sobre mileage e home office'
                          : 'Guidance on mileage and home office'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Planejamento para reduzir Self-Employment Tax'
                          : 'Planning to reduce Self-Employment Tax'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Deduções Comuns */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-money-dollar-circle-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Deduções Comuns para Autônomos' : 'Common Deductions for Self-Employed'}
                  </h4>
                </div>
                <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Mileage (quilometragem) para trabalho'
                          : 'Mileage for work'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Home office (escritório em casa)'
                          : 'Home office'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Equipamentos e ferramentas de trabalho'
                          : 'Work equipment and tools'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Internet, telefone e software'
                          : 'Internet, phone, and software'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Seguro saúde (Health Insurance)'
                          : 'Health Insurance'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-amber-600 to-amber-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-briefcase-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Organize Suas Finanças de Autônomo' : 'Organize Your Self-Employed Finances'}
                </h4>
                <p className="text-amber-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Maximize suas deduções e pague apenas o imposto necessário'
                    : 'Maximize your deductions and pay only the necessary tax'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Informações sobre ITIN */}
      {showItinModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowItinModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">ITIN - Individual Taxpayer Identification Number</h3>
                  <p className="text-green-100 text-sm">{currentLang === 'pt' ? 'Solicitação e Renovação' : 'Application and Renewal'}</p>
                </div>
              </div>
              <button onClick={() => setShowItinModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é ITIN */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-question-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é o ITIN?' : 'What is ITIN?'}
                  </h4>
                </div>
                <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'O ITIN é um número emitido pelo IRS para pessoas que precisam declarar imposto nos Estados Unidos, mas não são elegíveis para um Social Security Number (SSN).'
                      : 'ITIN is a number issued by the IRS for people who need to file taxes in the United States but are not eligible for a Social Security Number (SSN).'}
                  </p>
                </div>
              </div>

              {/* Quando Aplicar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-file-add-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Aplicar para o ITIN' : 'When to Apply for ITIN'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <p className="text-gray-700 mb-4">
                    {currentLang === 'pt' ? 'Você deve aplicar para um ITIN se:' : 'You should apply for an ITIN if:'}
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Precisa declarar imposto nos EUA'
                          : 'You need to file taxes in the US'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Teve renda nos Estados Unidos'
                          : 'You had income in the United States'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'É dependente ou cônjuge em uma declaração'
                          : 'You are a dependent or spouse on a tax return'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Não é elegível para um SSN'
                          : 'You are not eligible for an SSN'}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-4 bg-blue-100 border border-blue-300 rounded-lg p-4 flex items-start gap-3">
                    <i className="ri-information-line text-blue-600 text-xl mt-0.5"></i>
                    <p className="text-sm text-gray-700">
                      {currentLang === 'pt'
                        ? 'A aplicação do ITIN normalmente é feita junto com a primeira declaração de imposto e exige documentação específica, como passaporte válido ou documentos certificados.'
                        : 'ITIN application is typically done with your first tax return and requires specific documentation, such as a valid passport or certified documents.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Quando Renovar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-refresh-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Renovar o ITIN' : 'When to Renew ITIN'}
                  </h4>
                </div>
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                  <p className="text-gray-700 mb-4">
                    {currentLang === 'pt' ? 'Você deve renovar o ITIN se:' : 'You should renew your ITIN if:'}
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Seu ITIN não foi usado em declarações nos últimos 3 anos, ou'
                          : 'Your ITIN has not been used on tax returns in the last 3 years, or'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'O IRS notificou que seu ITIN expirou ou está prestes a expirar'
                          : 'The IRS notified you that your ITIN has expired or is about to expire'}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
                    <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                    <p className="text-sm text-gray-700">
                      <strong>{currentLang === 'pt' ? 'Importante:' : 'Important:'}</strong> {currentLang === 'pt' ? 'Um ITIN expirado não pode ser usado para declarar imposto nem para solicitar créditos fiscais até que seja renovado.' : 'An expired ITIN cannot be used to file taxes or claim tax credits until it is renewed.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Vantagens */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-star-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Vantagens de Manter o ITIN Ativo' : 'Benefits of Keeping ITIN Active'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Ajuda a construir histórico de crédito (credit score)'
                          : 'Helps build credit history (credit score)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Permite declarar imposto corretamente e em dia'
                          : 'Allows you to file taxes correctly and on time'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Evita atrasos no processamento da declaração'
                          : 'Avoids delays in processing your tax return'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Evita bloqueio de créditos fiscais elegíveis'
                          : 'Prevents blocking of eligible tax credits'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Mantém seu histórico fiscal regularizado com o IRS'
                          : 'Keeps your tax history up to date with the IRS'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Reduz riscos de notificações e problemas futuros'
                          : 'Reduces risks of notices and future problems'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Importante Saber */}
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gray-200 rounded-full flex-shrink-0">
                    <i className="ri-information-line text-2xl text-gray-600"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Importante Saber' : 'Important to Know'}</h5>
                    <p className="text-gray-700">
                      {currentLang === 'pt'
                        ? 'O ITIN não autoriza trabalho nos EUA, não substitui o SSN e não altera status imigratório.'
                        : 'ITIN does not authorize work in the US, does not replace SSN, and does not change immigration status.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Somos Acceptance Agent */}
              <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-verified-badge-fill text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Somos Certified Acceptance Agent' : 'We are Certified Acceptance Agent'}
                </h4>
                <p className="text-green-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Certificados pelo IRS para autenticar documentos e facilitar o processo de aplicação e renovação do ITIN'
                    : 'Certified by the IRS to authenticate documents and facilitate the ITIN application and renewal process'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Informações sobre Tax Return */}
      {showTaxInfoModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowTaxInfoModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-file-text-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Declaração de Imposto de Renda (Tax Return)' : 'Tax Return - Individual Income Tax'}</h3>
                  <p className="text-blue-100 text-sm">{currentLang === 'pt' ? 'Tudo que você precisa saber' : 'Everything you need to know'}</p>
                </div>
              </div>
              <button onClick={() => setShowTaxInfoModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* Quem Precisa Declarar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-user-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quem Precisa Declarar?' : 'Who Needs to File?'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Toda pessoa que trabalhou ou teve qualquer tipo de renda nos Estados Unidos em 2024 pode ser obrigada a declarar o imposto de renda, independentemente do valor recebido.'
                      : 'Anyone who worked or had any type of income in the United States in 2024 may be required to file a tax return, regardless of the amount received.'}
                  </p>
                </div>
              </div>

              {/* Documentos Necessários */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-folder-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-file-list-line text-blue-600"></i>
                      {currentLang === 'pt' ? 'Documentos de Renda' : 'Income Documents'}
                    </h5>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registro de receitas e despesas do negócio' : 'Record of business income and expenses'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>1099-NEC / 1099-K {currentLang === 'pt' ? '(recebidos de clientes)' : '(received from clients)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Recibos de despesas dedutíveis (materiais, transporte, home office, etc.)' : 'Receipts for deductible expenses (materials, transportation, home office, etc.)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Comprovantes de pagamento de estimated taxes (se aplicável)' : 'Proof of estimated tax payments (if applicable)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'ou SSN do proprietário' : 'or owner\'s SSN'}</span></li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-file-shield-line text-blue-600"></i>
                      {currentLang === 'pt' ? 'Documentos Pessoais' : 'Personal Documents'}
                    </h5>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Cópia da declaração do ano anterior' : 'Copy of prior year tax return'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Informações bancárias (para depósito direto)' : 'Bank account info (for direct deposit)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>Form 1095-A, B ou C {currentLang === 'pt' ? '(seguro saúde)' : '(health insurance)'}</span></li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-subtract-line text-blue-600"></i>
                      {currentLang === 'pt' ? 'Deduções' : 'Deductions'}
                    </h5>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>Form 1098 {currentLang === 'pt' ? '(juros de hipoteca)' : '(mortgage interest)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Recibos de doações' : 'Charitable donation receipts'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Despesas médicas' : 'Medical expenses'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Impostos estaduais/locais pagos' : 'State/local taxes paid'}</span></li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-money-dollar-circle-line text-blue-600"></i>
                      {currentLang === 'pt' ? 'Créditos' : 'Credits'}
                    </h5>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Despesas com creche/daycare' : 'Childcare/daycare expenses'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>Form 1098-T - {currentLang === 'pt' ? 'Créditos educacionais (American Opportunity Credit e Lifetime Learning Credit)' : 'Education Credits (American Opportunity Credit and Lifetime Learning Credit)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Crédito para Veículos Elétricos - Para compra de veículos elétricos elegíveis (novos ou usados, conforme regras)' : 'Electric Vehicle Credit - For purchase of eligible electric vehicles (new or used, per rules)'}</span></li>
                      <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Adoção (Form 8839)' : 'Adoption (Form 8839)'}</span></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Prazos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-calendar-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Prazos Importantes' : 'Important Deadlines'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-3">
                        <i className="ri-calendar-check-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Prazo Normal' : 'Regular Deadline'}</h5>
                      <p className="text-3xl font-bold text-blue-600 mb-2">15 de Abril</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Declaração sem multa' : 'File without penalty'}</p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-6 border border-amber-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-amber-600 rounded-full mx-auto mb-3">
                        <i className="ri-time-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Extensão' : 'Extension'}</h5>
                      <p className="text-3xl font-bold text-amber-600 mb-2">15 de Outubro</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Com Tax Extension (Form 4868)' : 'With Tax Extension (Form 4868)'}</p>
                    </div>
                  </div>
                </div>
                <div className="mt-4 bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
                  <i className="ri-information-line text-amber-600 text-xl mt-0.5"></i>
                  <p className="text-sm text-gray-700">
                    <strong>{currentLang === 'pt' ? 'Importante:' : 'Important:'}</strong> {currentLang === 'pt' ? 'A extensão dá mais tempo para enviar a declaração, mas não para pagar os impostos devidos. Impostos devem ser pagos até 15 de abril para evitar juros.' : 'Extension gives more time to file, but not to pay taxes owed. Taxes must be paid by April 15 to avoid interest.'}
                  </p>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-center">
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa de Ajuda com sua Declaração?' : 'Need Help with Your Tax Return?'}
                </h4>
                <p className="text-blue-100 mb-6">
                  {currentLang === 'pt' ? 'Nossa equipe está pronta para preparar sua declaração com precisão e maximizar sua restituição' : 'Our team is ready to prepare your return accurately and maximize your refund'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Informações sobre Tax Extension */}
      {showTaxExtensionModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowTaxExtensionModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-amber-500 to-amber-600 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-calendar-check-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Tax Extension (Extensão de Prazo)' : 'Tax Extension (Filing Deadline Extension)'}</h3>
                  <p className="text-amber-100 text-sm">{currentLang === 'pt' ? 'Entenda quando e por que solicitar' : 'Understand when and why to request'}</p>
                </div>
              </div>
              <button onClick={() => setShowTaxExtensionModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é Tax Extension */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-question-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é a Tax Extension?' : 'What is a Tax Extension?'}
                  </h4>
                </div>
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'A extensão de prazo serve apenas para adiar a entrega da declaração de imposto, e não o pagamento do imposto devido.'
                      : 'The tax extension only postpones the filing deadline for your tax return, not the payment of taxes owed.'}
                  </p>
                </div>
              </div>

              {/* Importante Saber */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg">
                    <i className="ri-error-warning-line text-xl text-red-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Importante Saber' : 'Important to Know'}
                  </h4>
                </div>
                <div className="bg-red-50 rounded-xl p-6 border border-red-200">
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-red-500 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Se houver imposto a pagar, o valor deve ser pago até o prazo original da declaração (15 de abril). Se você ainda deve impostos ao IRS de anos anteriores, é recomendável pagar o saldo devedor, pois os acréscimos de juros e multas são equivalentes aos do parcelamento.'
                          : 'If you owe taxes, the amount must be paid by the original filing deadline (April 15). If you still owe taxes to the IRS from previous years, it is recommended to pay the outstanding balance, as the interest and penalty charges are equivalent to those of an installment plan.'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-red-500 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Caso o pagamento não seja feito até essa data, o IRS aplicará juros e multas sobre o saldo em aberto.'
                          : 'If payment is not made by this date, the IRS will apply interest and penalties on the outstanding balance.'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Quando é Recomendável */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-thumb-up-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando é Recomendável Solicitar?' : 'When is it Recommended to Request?'}
                  </h4>
                </div>
                <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    {currentLang === 'pt'
                      ? 'Mesmo assim, em muitos casos, solicitar a extensão é recomendável:'
                      : 'Even so, in many cases, requesting an extension is recommended:'}
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Quando a declaração não está pronta a tempo, a extensão evita a multa por atraso na entrega, que é significativamente maior do que a multa por atraso no pagamento.'
                          : 'When the return is not ready on time, the extension avoids the late filing penalty, which is significantly higher than the late payment penalty.'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Se você ainda está pagando impostos de anos anteriores ou sabe que terá imposto a pagar neste ano, pode ser viável solicitar a extensão e realizar um pagamento estimado agora.'
                          : 'If you are still paying taxes from previous years or know you will owe taxes this year, it may be viable to request an extension and make an estimated payment now.'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Prazos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-calendar-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Prazos' : 'Deadlines'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-3">
                        <i className="ri-calendar-check-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Prazo para Solicitar Extensão' : 'Extension Request Deadline'}</h5>
                      <p className="text-3xl font-bold text-blue-600 mb-2">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Mesmo prazo da declaração original' : 'Same as original filing deadline'}</p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-6 border border-amber-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-amber-600 rounded-full mx-auto mb-3">
                        <i className="ri-time-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Novo Prazo com Extensão' : 'New Deadline with Extension'}</h5>
                      <p className="text-3xl font-bold text-amber-600 mb-2">{currentLang === 'pt' ? '15 de Outubro' : 'October 15'}</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? '6 meses adicionais para entregar' : '6 additional months to file'}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Análise Individual */}
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                    <i className="ri-user-search-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Cada Situação é Única' : 'Every Situation is Unique'}</h5>
                    <p className="text-gray-700">
                      {currentLang === 'pt'
                        ? 'Cada situação deve ser analisada individualmente para definir a melhor estratégia. Nossa equipe pode ajudar você a entender se a extensão é a melhor opção para o seu caso.'
                        : 'Each situation must be analyzed individually to determine the best strategy. Our team can help you understand if an extension is the best option for your case.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-2-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa de Ajuda com Tax Extension?' : 'Need Help with Tax Extension?'}
                </h4>
                <p className="text-amber-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Nossa equipe pode analisar sua situação e recomendar a melhor estratégia'
                    : 'Our team can analyze your situation and recommend the best strategy'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Tax Return Pessoa Jurídica (Business) */}
      {showBusinessTaxModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowBusinessTaxModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-sky-600 to-blue-700 text-white p-6 rounded-t-2xl flex items-center justify-between z-10">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-building-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">Tax Return {currentLang === 'pt' ? 'Pessoa Jurídica' : 'Business'}</h3>
                  <p className="text-sky-100 text-sm">{currentLang === 'pt' ? 'Documentos e prazos por tipo de empresa' : 'Documents and deadlines by business type'}</p>
                </div>
              </div>
              <button onClick={() => setShowBusinessTaxModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-10">

              {/* Intro */}
              <div className="bg-sky-50 rounded-xl p-6 border border-sky-200">
                <p className="text-gray-700 text-lg leading-relaxed">
                  {currentLang === 'pt'
                    ? 'Cada tipo de empresa nos EUA possui formulários, documentos e prazos específicos para a declaração de imposto. Confira abaixo os detalhes para cada estrutura empresarial.'
                    : 'Each type of business in the US has specific forms, documents, and deadlines for tax filing. Check below the details for each business structure.'}
                </p>
              </div>

              {/* ===== DBA / Sole Proprietorship ===== */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-user-star-line text-xl text-teal-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">DBA / Sole Proprietorship</h4>
                  <span className="bg-teal-100 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">Schedule C</span>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-folder-line text-teal-600"></i>
                        {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                      </h5>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registro de receitas e despesas do negócio' : 'Record of business income and expenses'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i><span>1099-NEC / 1099-K {currentLang === 'pt' ? '(recebidos de clientes)' : '(received from clients)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Recibos de despesas dedutíveis (materiais, transporte, home office, etc.)' : 'Receipts for deductible expenses (materials, transportation, home office, etc.)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Comprovantes de pagamento de estimated taxes (se aplicável)' : 'Proof of estimated tax payments (if applicable)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'ou SSN do proprietário' : 'or owner\'s SSN'}</span></li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-calendar-line text-teal-600"></i>
                        {currentLang === 'pt' ? 'Prazo de Entrega' : 'Filing Deadline'}
                      </h5>
                      <div className="bg-white rounded-lg p-4 border border-teal-200 text-center">
                        <p className="text-3xl font-bold text-teal-600 mb-1">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</p>
                        <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Declarado junto com o Form 1040 + Schedule C' : 'Filed with Form 1040 + Schedule C'}</p>
                      </div>
                      <div className="mt-3 bg-teal-100 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-information-line text-teal-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Com extensão: 15 de Outubro' : 'With extension: October 15'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== Partnership ===== */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 rounded-lg">
                    <i className="ri-group-line text-xl text-indigo-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Partnership</h4>
                  <span className="bg-indigo-100 text-indigo-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">Form 1065</span>
                </div>
                <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-folder-line text-indigo-600"></i>
                        {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                      </h5>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Acordo de parceria (Partnership Agreement)' : 'Partnership Agreement'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'da empresa' : 'of the business'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Demonstrações financeiras (Profit & Loss, Balance Sheet)' : 'Financial statements (Profit & Loss, Balance Sheet)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registro de receitas e despesas' : 'Record of income and expenses'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Informações de cada sócio (SSN/ITIN, % de participação)' : 'Information for each partner (SSN/ITIN, % ownership)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-indigo-600 mt-0.5"></i><span>1099s {currentLang === 'pt' ? 'recebidos e emitidos' : 'received and issued'}</span></li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-calendar-line text-indigo-600"></i>
                        {currentLang === 'pt' ? 'Prazo de Entrega' : 'Filing Deadline'}
                      </h5>
                      <div className="bg-white rounded-lg p-4 border border-indigo-200 text-center">
                        <p className="text-3xl font-bold text-indigo-600 mb-1">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</p>
                        <p className="text-sm text-gray-600">Form 1065 + Schedule K-1 {currentLang === 'pt' ? 'para cada sócio' : 'for each partner'}</p>
                      </div>
                      <div className="mt-3 bg-indigo-100 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-information-line text-indigo-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Com extensão: 15 de Setembro' : 'With extension: September 15'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== LLC Single Member ===== */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg">
                    <i className="ri-user-line text-xl text-emerald-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">LLC Single Member</h4>
                  <span className="bg-emerald-100 text-emerald-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">Schedule C</span>
                </div>
                <div className="bg-emerald-50 rounded-xl p-6 border border-emerald-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-folder-line text-emerald-600"></i>
                        {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                      </h5>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'da LLC' : 'of the LLC'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>Articles of Organization</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registro de receitas e despesas do negócio' : 'Record of business income and expenses'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>1099-NEC / 1099-K {currentLang === 'pt' ? '(recebidos)' : '(received)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Recibos de despesas dedutíveis' : 'Receipts for deductible expenses'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-emerald-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Extratos bancários da conta empresarial' : 'Business bank account statements'}</span></li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-calendar-line text-emerald-600"></i>
                        {currentLang === 'pt' ? 'Prazo de Entrega' : 'Filing Deadline'}
                      </h5>
                      <div className="bg-white rounded-lg p-4 border border-emerald-200 text-center">
                        <p className="text-3xl font-bold text-emerald-600 mb-1">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</p>
                        <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Declarado junto com o Form 1040 + Schedule C' : 'Filed with Form 1040 + Schedule C'}</p>
                      </div>
                      <div className="mt-3 bg-emerald-100 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-information-line text-emerald-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Com extensão: 15 de Outubro' : 'With extension: October 15'}
                      </div>
                      <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-alert-line text-amber-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Tributada como Disregarded Entity (mesma declaração do proprietário)' : 'Taxed as Disregarded Entity (same return as the owner)'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== LLC Multi Member ===== */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-100 rounded-lg">
                    <i className="ri-team-line text-xl text-cyan-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">LLC Multi Member</h4>
                  <span className="bg-cyan-100 text-cyan-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">Form 1065</span>
                </div>
                <div className="bg-cyan-50 rounded-xl p-6 border border-cyan-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-folder-line text-cyan-600"></i>
                        {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                      </h5>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'da LLC' : 'of the LLC'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>Articles of Organization + Operating Agreement</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Demonstrações financeiras (Profit & Loss, Balance Sheet)' : 'Financial statements (Profit & Loss, Balance Sheet)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Informações de cada membro (SSN/ITIN, % de participação)' : 'Information for each member (SSN/ITIN, % ownership)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registro de receitas e despesas' : 'Record of income and expenses'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-cyan-600 mt-0.5"></i><span>1099s {currentLang === 'pt' ? 'recebidos e emitidos' : 'received and issued'}</span></li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-calendar-line text-cyan-600"></i>
                        {currentLang === 'pt' ? 'Prazo de Entrega' : 'Filing Deadline'}
                      </h5>
                      <div className="bg-white rounded-lg p-4 border border-cyan-200 text-center">
                        <p className="text-3xl font-bold text-cyan-600 mb-1">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</p>
                        <p className="text-sm text-gray-600">Form 1065 + Schedule K-1 {currentLang === 'pt' ? 'para cada membro' : 'for each member'}</p>
                      </div>
                      <div className="mt-3 bg-cyan-100 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-information-line text-cyan-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Com extensão: 15 de Setembro' : 'With extension: September 15'}
                      </div>
                      <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-gray-700">
                        <i className="ri-alert-line text-amber-600 mr-1"></i>
                        {currentLang === 'pt' ? 'Tributada como Partnership por padrão' : 'Taxed as Partnership by default'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== S Corporation ===== */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-sky-100 rounded-lg">
                    <i className="ri-building-line text-xl text-sky-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">S Corporation (S Corp)</h4>
                  <span className="bg-sky-100 text-sky-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">Form 1120-S</span>
                </div>
                <div className="bg-sky-50 rounded-xl p-6 border border-sky-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-folder-line text-sky-600"></i>
                        {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                      </h5>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>EIN {currentLang === 'pt' ? 'da empresa' : 'of the business'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>Articles of Incorporation</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Carta de aprovação do IRS (Form 2553)' : 'IRS approval letter (Form 2553)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Demonstrações financeiras (Profit & Loss, Balance Sheet)' : 'Financial statements (Profit & Loss, Balance Sheet)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Informações de cada acionista (SSN/ITIN, % de participação)' : 'Information for each shareholder (SSN/ITIN, % ownership)'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>W-2 {currentLang === 'pt' ? 'dos sócios que recebem salário' : 'of shareholders receiving salary'}</span></li>
                        <li className="flex items-start gap-2"><i className="ri-arrow-right-s-line text-sky-600 mt-0.5"></i><span>{currentLang === 'pt' ? 'Registros de payroll e impostos retidos' : 'Payroll records and withheld taxes'}</span></li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-calendar-line text-sky-600"></i>
                        {currentLang === 'pt' ? 'Prazo de Entrega' : 'Filing Deadline'}
                      </h5>
                      <div className="bg-white rounded-lg p-4 border border-sky-200 text-center">
                        <p className="text-3xl font-bold text-sky-600 mb-1">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</p>
                        <p className="text-sm text-gray-600">Form 1120-S</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Resumo de Prazos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-calendar-check-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Resumo dos Prazos' : 'Deadline Summary'}
                  </h4>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="text-left p-3 rounded-tl-lg font-bold text-gray-900">{currentLang === 'pt' ? 'Tipo de Empresa' : 'Business Type'}</th>
                        <th className="text-center p-3 font-bold text-gray-900">{currentLang === 'pt' ? 'Formulário' : 'Form'}</th>
                        <th className="text-center p-3 font-bold text-gray-900">{currentLang === 'pt' ? 'Prazo Normal' : 'Regular Deadline'}</th>
                        <th className="text-center p-3 rounded-tr-lg font-bold text-gray-900">{currentLang === 'pt' ? 'Com Extensão' : 'With Extension'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-200">
                        <td className="p-3 text-gray-700 font-medium">DBA / Sole Proprietorship</td>
                        <td className="p-3 text-center text-gray-600">1040 + Schedule C</td>
                        <td className="p-3 text-center font-semibold text-teal-600">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Outubro' : 'October 15'}</td>
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50">
                        <td className="p-3 text-gray-700 font-medium">Partnership</td>
                        <td className="p-3 text-center text-gray-600">1065</td>
                        <td className="p-3 text-center font-semibold text-indigo-600">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Setembro' : 'September 15'}</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="p-3 text-gray-700 font-medium">LLC Single Member</td>
                        <td className="p-3 text-center text-gray-600">1040 + Schedule C</td>
                        <td className="p-3 text-center font-semibold text-emerald-600">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Outubro' : 'October 15'}</td>
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50">
                        <td className="p-3 text-gray-700 font-medium">LLC Multi Member</td>
                        <td className="p-3 text-center text-gray-600">1065</td>
                        <td className="p-3 text-center font-semibold text-cyan-600">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Setembro' : 'September 15'}</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="p-3 text-gray-700 font-medium">S Corporation</td>
                        <td className="p-3 text-center text-gray-600">1120-S</td>
                        <td className="p-3 text-center font-semibold text-sky-600">{currentLang === 'pt' ? '15 de Março' : 'March 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Setembro' : 'September 15'}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-700 font-medium">C Corporation</td>
                        <td className="p-3 text-center text-gray-600">1120</td>
                        <td className="p-3 text-center font-semibold text-blue-600">{currentLang === 'pt' ? '15 de Abril' : 'April 15'}</td>
                        <td className="p-3 text-center text-gray-600">{currentLang === 'pt' ? '15 de Outubro' : 'October 15'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Alerta Importante */}
              <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-200 rounded-full flex-shrink-0">
                    <i className="ri-error-warning-line text-2xl text-amber-700"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Importante' : 'Important'}</h5>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-amber-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Multa por atraso na entrega de Partnership e S Corp: $220 por sócio/acionista por mês de atraso (2024).'
                          : 'Late filing penalty for Partnership and S Corp: $220 per partner/shareholder per month late (2024).'}
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-amber-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Manter a contabilidade (bookkeeping) em dia facilita e agiliza a preparação da declaração.'
                          : 'Keeping bookkeeping up to date facilitates and speeds up return preparation.'}
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-amber-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Cada situação deve ser analisada individualmente. Consulte nossa equipe para definir a melhor estratégia para sua empresa.'
                          : 'Each situation should be analyzed individually. Consult our team to define the best strategy for your business.'}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-sky-600 to-blue-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-2-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa de Ajuda com a Declaração da Sua Empresa?' : 'Need Help with Your Business Tax Return?'}
                </h4>
                <p className="text-sky-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Nossa equipe é especializada em declarações empresariais. Enrolled Agent credenciado pelo IRS para representar sua empresa.'
                    : 'Our team specializes in business tax returns. Enrolled Agent credentialed by the IRS to represent your business.'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal: Consultoria Fiscal */}
      {showConsultingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowConsultingModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-purple-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-lightbulb-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Consultoria Fiscal' : 'Tax Consulting'}</h3>
                  <p className="text-purple-100 text-sm">{currentLang === 'pt' ? 'Planejamento e estratégias fiscais personalizadas' : 'Personalized tax planning and strategies'}</p>
                </div>
              </div>
              <button onClick={() => setShowConsultingModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-lg">
                    <i className="ri-question-line text-xl text-purple-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Consultoria Fiscal?' : 'What is Tax Consulting?'}
                  </h4>
                </div>
                <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Consultoria fiscal é um serviço especializado que ajuda você a entender suas obrigações tributárias, planejar estratégias para reduzir impostos legalmente e tomar decisões financeiras mais inteligentes.'
                      : 'Tax consulting is a specialized service that helps you understand your tax obligations, plan strategies to legally reduce taxes, and make smarter financial decisions.'}
                  </p>
                </div>
              </div>

              {/* Quando Contratar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-calendar-check-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Contratar?' : 'When to Hire?'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Mudança de status imigratório (Green Card, cidadania)'
                          : 'Immigration status change (Green Card, citizenship)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Abertura ou mudança de estrutura empresarial'
                          : 'Opening or changing business structure'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Compra ou venda de imóveis'
                          : 'Buying or selling real estate'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Investimentos nos EUA ou no exterior'
                          : 'Investments in the US or abroad'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Planejamento de aposentadoria'
                          : 'Retirement planning'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Recebimento de herança ou doações'
                          : 'Receiving inheritance or gifts'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* O Que Inclui */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-checkbox-circle-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Inclui a Consultoria?' : 'What Does Consulting Include?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Análise da situação fiscal atual'
                          : 'Analysis of current tax situation'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Planejamento tributário personalizado'
                          : 'Personalized tax planning'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Estratégias para redução legal de impostos'
                          : 'Strategies for legal tax reduction'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Orientação sobre deduções e créditos'
                          : 'Guidance on deductions and credits'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Projeções fiscais para decisões futuras'
                          : 'Tax projections for future decisions'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Suporte em auditorias do IRS'
                          : 'Support in IRS audits'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Benefícios */}
              <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-star-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Benefícios da Consultoria' : 'Consulting Benefits'}
                </h4>
                <p className="text-purple-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Economize dinheiro, evite problemas com o IRS e tome decisões financeiras mais inteligentes'
                    : 'Save money, avoid IRS problems, and make smarter financial decisions'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Notary Public */}
      {showNotaryModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowNotaryModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-file-shield-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">Notary Public</h3>
                  <p className="text-indigo-100 text-sm">{currentLang === 'pt' ? 'Autenticação de documentos oficiais' : 'Official document authentication'}</p>
                </div>
              </div>
              <button onClick={() => setShowNotaryModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 rounded-lg">
                    <i className="ri-question-line text-xl text-indigo-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Notary Public?' : 'What is Notary Public?'}
                  </h4>
                </div>
                <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Notary Public é um oficial público autorizado pelo estado a autenticar assinaturas, certificar cópias de documentos e administrar juramentos. É essencial para validar documentos legais e prevenir fraudes.'
                      : 'Notary Public is a public official authorized by the state to authenticate signatures, certify document copies, and administer oaths. It is essential for validating legal documents and preventing fraud.'}
                  </p>
                </div>
              </div>

              {/* Quando Usar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-file-list-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Usar Notary Public?' : 'When to Use Notary Public?'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Procurações (Power of Attorney)'
                          : 'Power of Attorney documents'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Contratos de compra e venda'
                          : 'Purchase and sale contracts'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Documentos imobiliários (Deeds, Affidavits)'
                          : 'Real estate documents (Deeds, Affidavits)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Documentos para uso no Brasil ou outros países'
                          : 'Documents for use in Brazil or other countries'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Testamentos e documentos de herança'
                          : 'Wills and inheritance documents'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Documentos de imigração'
                          : 'Immigration documents'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Documentos Necessários */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-folder-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que Você Precisa Trazer?' : 'What You Need to Bring?'}
                  </h4>
                </div>
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Documento de identificação válido com foto (Driver\'s License, Passport, State ID)'
                          : 'Valid photo ID (Driver\'s License, Passport, State ID)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'O documento original que precisa ser autenticado (não assinado ainda)'
                          : 'The original document to be notarized (not signed yet)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Todas as partes envolvidas devem estar presentes'
                          : 'All parties involved must be present'}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
                    <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                    <p className="text-sm text-gray-700">
                      <strong>{currentLang === 'pt' ? 'Importante:' : 'Important:'}</strong> {currentLang === 'pt' ? 'Não assine o documento antes de comparecer ao Notary. A assinatura deve ser feita na presença do notário.' : 'Do not sign the document before appearing before the Notary. The signature must be made in the presence of the notary.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-verified-badge-fill text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa Autenticar Documentos?' : 'Need to Notarize Documents?'}
                </h4>
                <p className="text-indigo-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Serviço rápido e profissional de Notary Public. Agende seu horário!'
                    : 'Fast and professional Notary Public service. Schedule your appointment!'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Renovação de Passaporte */}
      {showPassportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowPassportModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-teal-600 to-teal-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-passport-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Renovação de Passaporte Brasileiro' : 'Brazilian Passport Renewal'}</h3>
                  <p className="text-teal-100 text-sm">{currentLang === 'pt' ? 'Assistência completa para renovação' : 'Complete renewal assistance'}</p>
                </div>
              </div>
              <button onClick={() => setShowPassportModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-question-line text-xl text-teal-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Como Funciona o Serviço?' : 'How Does the Service Work?'}
                  </h4>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Oferecemos assistência completa no processo de renovação do passaporte brasileiro, incluindo preenchimento de formulários, orientação sobre documentos necessários e agendamento no consulado.'
                      : 'We offer complete assistance in the Brazilian passport renewal process, including form filling, guidance on required documents, and consulate scheduling.'}
                  </p>
                </div>
              </div>

              {/* Quando Renovar */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-calendar-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando Renovar?' : 'When to Renew?'}
                  </h4>
                </div>
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Passaporte vencido ou próximo do vencimento'
                          : 'Expired or soon-to-expire passport'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Passaporte sem páginas disponíveis para vistos'
                          : 'Passport without available pages for visas'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Mudança de nome (casamento, divórcio)'
                          : 'Name change (marriage, divorce)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Passaporte danificado ou extraviado'
                          : 'Damaged or lost passport'}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3">
                    <i className="ri-information-line text-blue-600 text-xl mt-0.5"></i>
                    <p className="text-sm text-gray-700">
                      <strong>{currentLang === 'pt' ? 'Dica:' : 'Tip:'}</strong> {currentLang === 'pt' ? 'Recomenda-se renovar o passaporte com pelo menos 6 meses de antecedência do vencimento, especialmente se você planeja viajar.' : 'It is recommended to renew your passport at least 6 months before expiration, especially if you plan to travel.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Documentos Necessários */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-folder-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Documentos Necessários' : 'Required Documents'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Passaporte brasileiro atual (mesmo vencido)'
                          : 'Current Brazilian passport (even if expired)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Documento de identidade brasileiro (RG ou CNH)'
                          : 'Brazilian identity document (RG or CNH)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'CPF'
                          : 'CPF (Brazilian tax ID)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Comprovante de residência nos EUA'
                          : 'Proof of US residence'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Foto recente (conforme especificações do consulado)'
                          : 'Recent photo (according to consulate specifications)'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Certidão de casamento ou divórcio (se houver mudança de nome)'
                          : 'Marriage or divorce certificate (if name change)'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Como Ajudamos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-hand-heart-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Como Podemos Ajudar?' : 'How Can We Help?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preenchimento correto de formulários'
                          : 'Correct form filling'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Orientação sobre documentos necessários'
                          : 'Guidance on required documents'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Agendamento no consulado'
                          : 'Consulate appointment scheduling'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Suporte durante todo o processo'
                          : 'Support throughout the process'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-passport-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa Renovar seu Passaporte?' : 'Need to Renew Your Passport?'}
                </h4>
                <p className="text-teal-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Facilitamos todo o processo de renovação do seu passaporte brasileiro'
                    : 'We facilitate the entire Brazilian passport renewal process'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Regularização Fiscal */}
      {showRegularizationModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowRegularizationModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-orange-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-file-shield-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Regularização Fiscal' : 'Tax Regularization'}</h3>
                  <p className="text-orange-100 text-sm">{currentLang === 'pt' ? 'Resolva pendências com o IRS' : 'Resolve IRS issues'}</p>
                </div>
              </div>
              <button onClick={() => setShowRegularizationModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className="ri-question-line text-xl text-orange-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que é Regularização Fiscal?' : 'What is Tax Regularization?'}
                  </h4>
                </div>
                <div className="bg-orange-50 rounded-xl p-6 border border-orange-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Regularização fiscal é o processo de resolver pendências tributárias com o IRS, incluindo declarações atrasadas, impostos não pagos, multas e juros acumulados. Ajudamos você a se regularizar e evitar problemas maiores.'
                      : 'Tax regularization is the process of resolving tax issues with the IRS, including late returns, unpaid taxes, accumulated penalties and interest. We help you get compliant and avoid bigger problems.'}
                  </p>
                </div>
              </div>

              {/* Quando é Necessário */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg">
                    <i className="ri-alert-line text-xl text-red-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Quando é Necessário?' : 'When is it Necessary?'}
                  </h4>
                </div>
                <div className="bg-red-50 rounded-xl p-6 border border-red-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Declarações de anos anteriores não foram entregues'
                          : 'Prior year tax returns were not filed'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Impostos devidos não foram pagos'
                          : 'Owed taxes were not paid'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Recebeu notificações do IRS sobre pendências'
                          : 'Received IRS notices about outstanding issues'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Multas e juros estão acumulando'
                          : 'Penalties and interest are accumulating'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-error-warning-line text-red-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        {currentLang === 'pt'
                          ? 'Precisa regularizar situação para obter empréstimos ou vistos'
                          : 'Need to regularize status for loans or visas'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Como Ajudamos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-hand-heart-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Como Podemos Ajudar?' : 'How Can We Help?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preparação de declarações atrasadas'
                          : 'Preparation of late tax returns'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Negociação de planos de pagamento com o IRS'
                          : 'Negotiation of payment plans with the IRS'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Redução de multas e juros (Penalty Abatement)'
                          : 'Penalty and interest reduction (Penalty Abatement)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Representação perante o IRS'
                          : 'Representation before the IRS'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Análise de situação fiscal completa'
                          : 'Complete tax situation analysis'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Estratégias para minimizar dívidas'
                          : 'Strategies to minimize debts'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Importante */}
              <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-200 rounded-full flex-shrink-0">
                    <i className="ri-information-line text-2xl text-amber-700"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Importante' : 'Important'}</h5>
                    <p className="text-gray-700 mb-3">
                      {currentLang === 'pt'
                        ? 'Quanto mais tempo você esperar, maiores serão as multas e juros. Regularizar sua situação o quanto antes é fundamental para evitar problemas maiores, como penhora de bens ou bloqueio de contas.'
                        : 'The longer you wait, the higher the penalties and interest. Regularizing your situation as soon as possible is essential to avoid bigger problems, such as property seizure or account freezing.'}
                    </p>
                    <p className="text-gray-700 text-sm">
                      {currentLang === 'pt'
                        ? 'Como Enrolled Agent, temos autorização do IRS para representar você e negociar em seu nome.'
                        : 'As an Enrolled Agent, we have IRS authorization to represent you and negotiate on your behalf.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-2-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa Regularizar sua Situação Fiscal?' : 'Need to Regularize Your Tax Situation?'}
                </h4>
                <p className="text-orange-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Não deixe as pendências crescerem. Resolva agora com nossa ajuda especializada'
                    : 'Don\'t let issues grow. Resolve now with our specialized help'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: IRS Notices */}
      {showIrsNoticesModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowIrsNoticesModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-slate-500 to-slate-600 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-mail-check-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Resposta a Notificações do IRS' : 'IRS Notices Response'}</h3>
                  <p className="text-slate-100 text-sm">{currentLang === 'pt' ? 'Resolva notificações com segurança' : 'Resolve notices safely'}</p>
                </div>
              </div>
              <button onClick={() => setShowIrsNoticesModal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-lg">
                    <i className="ri-question-line text-xl text-slate-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que São Notificações do IRS?' : 'What are IRS Notices?'}
                  </h4>
                </div>
                <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Notificações do IRS (IRS Notices) são cartas oficiais enviadas pelo IRS informando sobre problemas na sua declaração, impostos devidos, auditorias, ou solicitando informações adicionais. É crucial responder corretamente e dentro do prazo.'
                      : 'IRS Notices are official letters sent by the IRS informing about problems with your return, owed taxes, audits, or requesting additional information. It is crucial to respond correctly and within the deadline.'}
                  </p>
                </div>
              </div>

              {/* Tipos Comuns */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-file-list-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Tipos Comuns de Notificações' : 'Common Types of Notices'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>CP2000:</strong> {currentLang === 'pt'
                          ? 'Discrepância entre sua declaração e informações reportadas por terceiros'
                          : 'Discrepancy between your return and information reported by third parties'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>CP14:</strong> {currentLang === 'pt'
                          ? 'Você deve impostos ao IRS'
                          : 'You owe taxes to the IRS'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>CP501/503/504:</strong> {currentLang === 'pt'
                          ? 'Lembretes de impostos não pagos'
                          : 'Reminders of unpaid taxes'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>Letter 525:</strong> {currentLang === 'pt'
                          ? 'Solicitação de informações adicionais'
                          : 'Request for additional information'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>Letter 566:</strong> {currentLang === 'pt'
                          ? 'Notificação de auditoria'
                          : 'Audit notification'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Como Ajudamos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-shield-check-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Como Podemos Ajudar?' : 'How Can We Help?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Análise detalhada da notificação'
                          : 'Detailed notice analysis'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preparação de resposta adequada'
                          : 'Preparation of appropriate response'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Representação perante o IRS'
                          : 'Representation before the IRS'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Negociação de acordos de pagamento'
                          : 'Negotiation of payment agreements'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Contestação de valores incorretos'
                          : 'Dispute of incorrect amounts'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Suporte em auditorias'
                          : 'Audit support'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Alerta Importante */}
              <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-200 rounded-full flex-shrink-0">
                    <i className="ri-alarm-warning-line text-2xl text-amber-700"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Atenção aos Prazos!' : 'Attention to Deadlines!'}</h5>
                    <p className="text-gray-700 mb-3">
                      {currentLang === 'pt'
                        ? 'A maioria das notificações do IRS tem prazo de resposta de 30 dias. Ignorar ou responder incorretamente pode resultar em multas maiores, juros acumulados e até ações legais.'
                        : 'Most IRS notices have a 30-day response deadline. Ignoring or responding incorrectly can result in higher penalties, accumulated interest, and even legal action.'}
                    </p>
                    <p className="text-gray-700 text-sm font-semibold">
                      {currentLang === 'pt'
                        ? '⚠️ Nunca ignore uma notificação do IRS! Entre em contato conosco imediatamente.'
                        : '⚠️ Never ignore an IRS notice! Contact us immediately.'}
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-slate-500 to-slate-600 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-check-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Recebeu uma Notificação do IRS?' : 'Received an IRS Notice?'}
                </h4>
                <p className="text-slate-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Não responda sozinho. Deixe nossos especialistas cuidarem disso para você'
                    : 'Don\'t respond alone. Let our specialists handle it for you'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Emissão de 1099s */}
      {show1099Modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShow1099Modal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-cyan-600 to-cyan-700 text-white p-6 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-file-list-3-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">{currentLang === 'pt' ? 'Emissão de 1099s' : '1099 Forms Issuance'}</h3>
                  <p className="text-cyan-100 text-sm">{currentLang === 'pt' ? 'Cumpra suas obrigações fiscais' : 'Meet your tax obligations'}</p>
                </div>
              </div>
              <button onClick={() => setShow1099Modal(false)} className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* O que é */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-100 rounded-lg">
                    <i className="ri-question-line text-xl text-cyan-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'O Que São os Formulários 1099?' : 'What are 1099 Forms?'}
                  </h4>
                </div>
                <div className="bg-cyan-50 rounded-xl p-6 border border-cyan-200">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {currentLang === 'pt' 
                      ? 'Formulários 1099 são documentos fiscais que empresas devem emitir para reportar pagamentos feitos a contratados independentes, freelancers e prestadores de serviços. Se sua empresa pagou $600 ou mais a um contratado durante o ano, você é obrigado a emitir um 1099.'
                      : '1099 forms are tax documents that businesses must issue to report payments made to independent contractors, freelancers, and service providers. If your business paid $600 or more to a contractor during the year, you are required to issue a 1099.'}
                  </p>
                </div>
              </div>

              {/* Tipos de 1099 */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-file-list-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Tipos Principais de 1099' : 'Main Types of 1099'}
                  </h4>
                </div>
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>1099-NEC:</strong> {currentLang === 'pt'
                          ? 'Pagamentos a contratados independentes e freelancers'
                          : 'Payments to independent contractors and freelancers'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>1099-MISC:</strong> {currentLang === 'pt'
                          ? 'Aluguéis, prêmios, royalties e outros pagamentos diversos'
                          : 'Rents, prizes, royalties, and other miscellaneous payments'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>1099-K:</strong> {currentLang === 'pt'
                          ? 'Pagamentos via cartão de crédito e plataformas de pagamento'
                          : 'Credit card and payment platform transactions'}
                      </p>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-s-line text-blue-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700">
                        <strong>1099-INT:</strong> {currentLang === 'pt'
                          ? 'Juros pagos'
                          : 'Interest paid'}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Prazos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className="ri-calendar-line text-xl text-amber-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Prazos Importantes' : 'Important Deadlines'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-6 border border-amber-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-amber-600 rounded-full mx-auto mb-3">
                        <i className="ri-mail-send-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Envio ao Contratado' : 'Send to Contractor'}</h5>
                      <p className="text-3xl font-bold text-amber-600 mb-2">{currentLang === 'pt' ? '31 de Janeiro' : 'January 31'}</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Prazo para enviar cópia ao contratado' : 'Deadline to send copy to contractor'}</p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-6 border border-red-200">
                    <div className="text-center">
                      <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-full mx-auto mb-3">
                        <i className="ri-government-line text-2xl text-white"></i>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Envio ao IRS' : 'Send to IRS'}</h5>
                      <p className="text-3xl font-bold text-red-600 mb-2">{currentLang === 'pt' ? '31 de Janeiro' : 'January 31'}</p>
                      <p className="text-sm text-gray-600">{currentLang === 'pt' ? 'Prazo para reportar ao IRS' : 'Deadline to report to IRS'}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Como Ajudamos */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-hand-heart-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">
                    {currentLang === 'pt' ? 'Como Podemos Ajudar?' : 'How Can We Help?'}
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Preparação e emissão de todos os formulários 1099'
                          : 'Preparation and issuance of all 1099 forms'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Envio eletrônico ao IRS (e-filing)'
                          : 'Electronic filing to IRS (e-filing)'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Envio de cópias aos contratados'
                          : 'Sending copies to contractors'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Coleta de informações W-9 dos contratados'
                          : 'Collection of W-9 information from contractors'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Garantia de conformidade com prazos'
                          : 'Ensuring compliance with deadlines'}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-green-600 text-xl mt-0.5"></i>
                      <p className="text-gray-700 text-sm">
                        {currentLang === 'pt'
                          ? 'Correção de formulários com erros'
                          : 'Correction of forms with errors'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Penalidades */}
              <div className="bg-red-50 rounded-xl p-6 border border-red-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-200 rounded-full flex-shrink-0">
                    <i className="ri-error-warning-line text-2xl text-red-700"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">{currentLang === 'pt' ? 'Penalidades por Atraso' : 'Late Penalties'}</h5>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-red-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Até 30 dias de atraso: $60 por formulário'
                          : 'Up to 30 days late: $60 per form'}
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-red-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? '31 dias até 1º de agosto: $120 por formulário'
                          : '31 days to August 1: $120 per form'}
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-red-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Após 1º de agosto ou não enviado: $310 por formulário'
                          : 'After August 1 or not filed: $310 per form'}
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-alert-line text-red-600 mt-0.5"></i>
                        {currentLang === 'pt'
                          ? 'Não envio intencional: mínimo de $630 por formulário'
                          : 'Intentional disregard: minimum $630 per form'}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-cyan-600 to-cyan-700 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-3-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {currentLang === 'pt' ? 'Precisa Emitir 1099s?' : 'Need to Issue 1099s?'}
                </h4>
                <p className="text-cyan-100 mb-6">
                  {currentLang === 'pt' 
                    ? 'Evite multas e garanta conformidade. Deixe a emissão dos seus 1099s conosco'
                    : 'Avoid penalties and ensure compliance. Leave your 1099 issuance to us'}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a 
                    href="https://wa.me/14153353243" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-400 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== 3. NÚMEROS ACUMULADOS ===== */}
      <section ref={countersRef} className="py-24 px-6 bg-gradient-to-br from-sky-400 via-blue-400 to-sky-500 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-sky-200 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto relative z-10">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {t('results.title')}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-10 text-center border border-white/30 hover:bg-white/25 transition-all">
              <div className="text-6xl md:text-7xl font-bold text-white mb-4">
                <span id="counter1">0</span>+
              </div>
              <p className="text-xl text-white/90 font-medium">{t('results.individual')}</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-10 text-center border border-white/30 hover:bg-white/25 transition-all">
              <div className="text-6xl md:text-7xl font-bold text-white mb-4">
                <span id="counter2">0</span>+
              </div>
              <p className="text-xl text-white/90 font-medium">{t('results.business')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== 4. REVIEWS ===== */}
      <section ref={testimonialsRef} className="py-24 px-6 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 text-sm font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-google-fill text-red-500"></i>
              {t('testimonials.badge')}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('testimonials.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-4">
              {t('testimonials.description')}
            </p>
            <p className="text-sm text-blue-700 font-bold flex items-center justify-center gap-2">
              <i className="ri-verified-badge-fill text-green-500"></i>
              {t('testimonials.verified')}
            </p>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden lg:grid grid-cols-3 gap-8 mb-12">
            {testimonials.map((testimonial, i) => (
              <div
                key={i}
                className={`bg-white border border-gray-100 rounded-2xl p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-500 ${testimonialsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, s) => (
                    <i key={s} className="ri-star-fill text-amber-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed mb-6 italic relative">
                  <span className="text-4xl text-blue-200 font-serif absolute -top-2 -left-1">&ldquo;</span>
                  <span className="pl-5">{testimonial.text}</span>
                </p>
                <span className="inline-block bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full mb-5">
                  {testimonial.service}
                </span>
                <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                  <div className="w-12 h-12 rounded-full bg-gray-200 border-2 border-gray-300 flex items-center justify-center">
                    <span className="text-gray-600 font-bold text-lg">{testimonial.name.charAt(0).toUpperCase()}</span>
                  </div>
                  <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile: Carrossel */}
          <div className="lg:hidden">
            <div className="overflow-hidden">
              <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${activeTestimonial * 100}%)` }}>
                {testimonials.map((testimonial, i) => (
                  <div key={i} className="w-full flex-shrink-0 px-2">
                    <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-md">
                      <div className="flex items-center gap-1 mb-4">
                        {Array.from({ length: testimonial.rating }).map((_, s) => (
                          <i key={s} className="ri-star-fill text-amber-400 text-lg"></i>
                        ))}
                      </div>
                      <p className="text-gray-700 leading-relaxed mb-6 italic relative">
                        <span className="text-4xl text-blue-200 font-serif absolute -top-2 -left-1">&ldquo;</span>
                        <span className="pl-5">{testimonial.text}</span>
                      </p>
                      <span className="inline-block bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full mb-5">
                        {testimonial.service}
                      </span>
                      <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                        <div className="w-12 h-12 rounded-full bg-gray-200 border-2 border-gray-300 flex items-center justify-center">
                          <span className="text-gray-600 font-bold text-lg">{testimonial.name.charAt(0).toUpperCase()}</span>
                        </div>
                        <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-center gap-4 mt-8">
              <button onClick={() => setActiveTestimonial(prev => Math.max(0, prev - 1))} disabled={activeTestimonial === 0} className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:bg-blue-50 hover:border-blue-300 transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
                <i className="ri-arrow-left-s-line text-xl"></i>
              </button>
              <div className="flex gap-2">
                {testimonials.map((_, i) => (
                  <button key={i} onClick={() => setActiveTestimonial(i)} className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${i === activeTestimonial ? 'bg-blue-500 w-6' : 'bg-gray-300'}`} />
                ))}
              </div>
              <button onClick={() => setActiveTestimonial(prev => Math.min(testimonials.length - 1, prev + 1))} disabled={activeTestimonial === testimonials.length - 1} className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:bg-blue-50 hover:border-blue-300 transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
                <i className="ri-arrow-right-s-line text-xl"></i>
              </button>
            </div>
          </div>

          {/* Google Reviews Summary */}
          <div className={`mt-16 bg-gradient-to-r from-blue-50 to-white rounded-2xl p-8 md:p-10 border border-blue-100 shadow-lg transition-all duration-700 ${testimonialsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: '600ms' }}>
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
              <div className="flex items-center gap-6">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-md">
                  <i className="ri-google-fill text-4xl text-[#4285F4]"></i>
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-5xl font-bold text-gray-900">4.9</span>
                    <div className="flex items-center gap-1">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xl text-amber-400"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-gray-600">{t('testimonials.basedOn')} <strong>209</strong> {t('testimonials.reviewsOn')}</p>
                </div>
              </div>
              <div className="flex items-center gap-8 text-center">
                <div>
                  <p className="text-2xl font-bold text-gray-900">98%</p>
                  <p className="text-gray-500 text-sm">{t('testimonials.satisfied')}</p>
                </div>
                <div className="w-px h-10 bg-gray-300"></div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">100%</p>
                  <p className="text-gray-500 text-sm">{t('testimonials.recommend')}</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a href="https://www.google.com/search?q=amiraco+tax+service+pinole+reviews" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sky-200 hover:text-white font-semibold transition-colors cursor-pointer">
                  <i className="ri-external-link-line"></i>
                  {t('testimonials.viewGoogle')}
                </a>
                <a href="https://wa.me/14153353243" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                  {t('nav.schedule')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== 5. TAXDOME CLIENT PORTAL ===== */}
      <section className="py-24 px-6 bg-gradient-to-br from-sky-600 via-blue-500 to-sky-700 overflow-hidden">
        <div className="container mx-auto">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-flex items-center gap-2 bg-white/15 text-sky-100 text-sm font-semibold px-4 py-2 rounded-full mb-4">
                <i className="ri-shield-check-line text-lg"></i>
                {t('taxdome.badge')}
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{t('taxdome.title')}</h2>
              <p className="text-lg text-sky-100 max-w-2xl mx-auto mb-4">
                {t('taxdome.description')}
              </p>
              <Link to="/tutorial-taxdome" className="inline-flex items-center gap-2 text-sky-200 hover:text-white font-semibold transition-colors cursor-pointer">
                <i className="ri-book-open-line"></i>
                {currentLang === 'pt' ? 'Ver Tutorial Completo' : 'View Complete Tutorial'}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Desktop Mockup - Laptop Style */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-sky-300/20 to-blue-400/20 rounded-3xl blur-3xl opacity-50 group-hover:opacity-70 transition-opacity"></div>
                <div className="relative">
                  {/* Laptop Screen */}
                  <div className="bg-gray-800 rounded-t-xl p-2 shadow-2xl border border-gray-700">
                    {/* Browser Chrome */}
                    <div className="bg-gray-700 rounded-t-lg px-4 py-2.5 flex items-center gap-3">
                      <div className="flex gap-1.5">
                        <div className="w-3 h-3 rounded-full bg-red-400"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                        <div className="w-3 h-3 rounded-full bg-green-400"></div>
                      </div>
                      <div className="flex-1 bg-gray-600 rounded-md px-4 py-1.5 text-sm text-gray-300 flex items-center gap-2">
                        <i className="ri-lock-line text-green-400 text-xs"></i>
                        amiracotax.taxdome.com
                      </div>
                    </div>
                    {/* Screen Content */}
                    <div className="aspect-[16/10] bg-gray-100 relative overflow-hidden rounded-b-lg">
                      <div className="absolute inset-0 flex flex-col justify-end p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('taxdome.loginTitle')}</h3>
                        <p className="text-gray-600 text-sm mb-4 max-w-md">{t('taxdome.loginDesc')}</p>
                        <a href="https://amiracotax.taxdome.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-sky-500 hover:bg-sky-600 text-white px-8 py-3 rounded-xl font-bold text-base hover:scale-105 transition-all shadow-lg whitespace-nowrap cursor-pointer w-fit">
                          <i className="ri-login-box-line text-xl"></i>
                          {t('taxdome.loginButton')}
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* Laptop Base / Hinge */}
                  <div className="relative mx-auto">
                    <div className="h-3 bg-gradient-to-b from-gray-700 to-gray-600 rounded-b-sm mx-4"></div>
                    <div className="h-2 bg-gradient-to-b from-gray-600 to-gray-500 rounded-b-lg mx-0"></div>
                    <div className="h-1 bg-gray-400/50 rounded-b-xl mx-8"></div>
                  </div>
                </div>
              </div>

              {/* iPhone Mockup */}
              <div className="relative flex justify-center lg:justify-end">
                <div className="absolute inset-0 bg-gradient-to-r from-sky-400/20 to-blue-300/20 rounded-3xl blur-3xl opacity-50"></div>
                <div className="relative">
                  <div className="w-72 bg-gray-900 rounded-[3rem] p-3 shadow-2xl border border-sky-500/30">
                    <div className="absolute top-6 left-1/2 -translate-x-1/2 w-28 h-7 bg-black rounded-full z-10"></div>
                    <div className="bg-white rounded-[2.5rem] overflow-hidden relative">
                      <div className="w-full h-[520px] bg-gray-100"></div>
                      <div className="absolute inset-0 flex flex-col justify-end p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('taxdome.appTitle')}</h3>
                        <p className="text-gray-600 text-sm mb-5">{t('taxdome.appDesc')}</p>
                        <div className="flex flex-col gap-3">
                          <a href="https://apps.apple.com/us/app/taxdome/id1472202357" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-black hover:bg-gray-900 text-white px-4 py-2.5 rounded-xl transition-all cursor-pointer">
                            <i className="ri-apple-fill text-2xl"></i>
                            <div className="text-left">
                              <span className="text-[10px] text-gray-400 block leading-tight">{t('taxdome.downloadOn')}</span>
                              <span className="text-sm font-bold leading-tight">App Store</span>
                            </div>
                          </a>
                          <a href="https://play.google.com/store/apps/details?id=com.taxdome&hl=en_US&gl=US" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-black hover:bg-gray-900 text-white px-4 py-2.5 rounded-xl transition-all cursor-pointer">
                            <i className="ri-google-play-fill text-2xl text-green-400"></i>
                            <div className="text-left">
                              <span className="text-[10px] text-gray-400 block leading-tight">{t('taxdome.getItOn')}</span>
                              <span className="text-sm font-bold leading-tight">Google Play</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-sky-400 rounded-2xl shadow-xl flex items-center justify-center animate-pulse">
                    <i className="ri-shield-check-fill text-white text-4xl"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Security Features */}
            <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-center gap-4 bg-white/25 backdrop-blur-sm rounded-xl p-5 border border-white/40">
                <div className="w-12 h-12 flex items-center justify-center bg-white/25 rounded-full flex-shrink-0">
                  <i className="ri-lock-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-white text-sm">{t('taxdome.feature1Title')}</h4>
                  <p className="text-sky-100 text-xs">{t('taxdome.feature1Desc')}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 bg-white/25 backdrop-blur-sm rounded-xl p-5 border border-white/40">
                <div className="w-12 h-12 flex items-center justify-center bg-white/25 rounded-full flex-shrink-0">
                  <i className="ri-file-shield-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-white text-sm">{t('taxdome.feature2Title')}</h4>
                  <p className="text-sky-100 text-xs">{t('taxdome.feature2Desc')}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 bg-white/25 backdrop-blur-sm rounded-xl p-5 border border-white/40">
                <div className="w-12 h-12 flex items-center justify-center bg-white/25 rounded-full flex-shrink-0">
                  <i className="ri-government-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-white text-sm">{t('taxdome.feature3Title')}</h4>
                  <p className="text-sky-100 text-xs">{t('taxdome.feature3Desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== 6. NOSSO TIME ===== */}
      <section id="time" className="py-24 px-6 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 text-sm font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-team-line text-lg"></i>
              {currentLang === 'pt' ? 'Nosso Time' : 'Our Team'}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('team.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('team.description')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto mb-16">
            <div className="text-center bg-gradient-to-b from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100/50">
              <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/e51f46fd291d36814275653916178eef.jpeg" alt="Victor Amira" className="w-56 h-56 rounded-full mx-auto mb-6 object-cover object-top border-4 border-blue-300 shadow-xl" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Victor Amira</h3>
              <p className="text-blue-600 font-semibold mb-1">{t('team.victor.role')}</p>
              <p className="text-blue-500 text-sm font-medium mb-4">{t('team.victor.education')}</p>
              <p className="text-gray-600 text-sm px-4 leading-relaxed">{t('team.victor.desc')}</p>
            </div>
            <div className="text-center bg-gradient-to-b from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100/50">
              <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/3e465d4d3b5f0bbeed10284da3333b54.jpeg" alt="Denise Amira" className="w-56 h-56 rounded-full mx-auto mb-6 object-cover object-top border-4 border-blue-300 shadow-xl" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Denise Amira</h3>
              <p className="text-blue-600 font-semibold mb-1">{t('team.denise.role')}</p>
              <p className="text-blue-500 text-sm font-medium mb-4">{t('team.denise.education')}</p>
              <p className="text-gray-600 text-sm px-4 leading-relaxed">{t('team.denise.desc')}</p>
            </div>
          </div>

          <div className="text-center mb-10">
            <h3 className="text-2xl font-bold text-gray-900">{t('team.support')}</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {['Isabel', 'Angelica', 'Roselaine', 'Rosa'].map((name) => (
              <div key={name} className="text-center">
                <div className="w-32 h-32 rounded-full mx-auto mb-4 bg-gradient-to-br from-blue-100 to-blue-200 border-3 border-blue-200 shadow-md flex items-center justify-center">
                  <i className="ri-user-line text-5xl text-blue-500"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{name}</h3>
                <p className="text-blue-500 font-medium text-sm">{t('team.assistant')}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA Intermediário ===== */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-500 to-blue-700">
        <div className="container mx-auto text-center max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">{t('cta.title')}</h2>
          <p className="text-xl text-white/90 mb-8">{t('cta.description')}</p>
          <a href="https://wa.me/14153353243" target="_blank" rel="noopener noreferrer" className="bg-white text-blue-700 px-10 py-5 rounded-xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            {t('cta.button')}
          </a>
        </div>
      </section>

      {/* ===== Sobre ===== */}
      <section id="sobre" className="py-24 px-6 bg-white">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center lg:text-left">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 text-sm font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-information-line text-lg"></i>
              {currentLang === 'pt' ? 'Quem Somos' : 'Who We Are'}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('about.title')}</h2>
            <div className="w-16 h-1 bg-blue-600 mb-8 mx-auto lg:mx-0"></div>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">{t('about.p1')}</p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">{t('about.p2')}</p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">{t('about.p3')}</p>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-2xl text-blue-600"></i>
                </div>
                <p className="text-gray-700 text-lg">{t('about.credential1')}</p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-2xl text-blue-600"></i>
                </div>
                <p className="text-gray-700 text-lg">{t('about.credential2')}</p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-2xl text-blue-600"></i>
                </div>
                <p className="text-gray-700 text-lg">{t('about.credential3')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Blog ===== */}
      <section id="blog" className="py-24 px-6 bg-gray-50">
        <div className="container mx-auto">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('blog.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl">{t('blog.description')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://public.readdy.ai/ai/img_res/84ef264c0dabd2940f0a4e6c7c96656d.jpg" alt="Tax Return 2024" className="w-full h-56 object-cover object-top" />
              <div className="p-6">
                <span className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full uppercase mb-3">Tax Return</span>
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-blue-600 transition-colors">{t('blog.post1.title')}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{t('blog.post1.desc')}</p>
                <p className="text-sm text-gray-400">15 de Janeiro, 2024</p>
              </div>
            </article>
            <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=ITIN%20application%20documents%20and%20passport%2C%20tax%20identification%20number%20paperwork%2C%20professional%20office%20setting%2C%20teal%20and%20white%20tones%2C%20organized%20workspace&width=600&height=400&seq=blog-post-2-v2&orientation=landscape" alt="ITIN" className="w-full h-56 object-cover object-top" />
              <div className="p-6">
                <span className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full uppercase mb-3">ITIN</span>
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-blue-600 transition-colors">{t('blog.post2.title')}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{t('blog.post2.desc')}</p>
                <p className="text-sm text-gray-400">10 de Janeiro, 2024</p>
              </div>
            </article>
            <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=entrepreneur%20opening%20new%20business%20in%20USA%2C%20LLC%20formation%20documents%2C%20modern%20workspace%20with%20laptop%20and%20documents%2C%20teal%20and%20white%20color%20scheme%2C%20professional%20business%20environment&width=600&height=400&seq=blog-post-3-v2&orientation=landscape" alt="Abertura de Empresa" className="w-full h-56 object-cover object-top" />
              <div className="p-6">
                <span className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full uppercase mb-3">{currentLang === 'pt' ? 'Empresas' : 'Business'}</span>
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-blue-600 transition-colors">{t('blog.post3.title')}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{t('blog.post3.desc')}</p>
                <p className="text-sm text-gray-400">5 de Janeiro, 2024</p>
              </div>
            </article>
          </div>
          <div className="text-center">
            <button className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:border-blue-700 hover:bg-blue-50 transition-all whitespace-nowrap cursor-pointer">
              {t('blog.viewAll')}
            </button>
          </div>
        </div>
      </section>

      {/* ===== Contato ===== */}
      <section id="contato" className="py-24 px-6 bg-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('contact.title')}</h2>
              <p className="text-lg text-gray-600 mb-10 leading-relaxed">{t('contact.description')}</p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t('contact.phone')}</h4>
                    <a href="tel:+14153353243" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">+1 (415) 335-3243</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t('contact.email')}</h4>
                    <a href="mailto:info@amiraco.com" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">info@amiraco.com</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t('contact.address')}</h4>
                    <p className="text-gray-600">2644 Appian Way, Suite 205<br />Pinole, CA 94564</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t('contact.hours')}</h4>
                    <p className="text-gray-600">
                      {t('contact.hoursWeekday')}<br />
                      {t('contact.hoursWeekend')}<br />
                      <span className="font-medium text-blue-600">{t('contact.hoursScheduled')}</span>
                    </p>
                  </div>
                </div>
                <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <a href="https://www.google.com/search?q=amiraco+tax+service+pinole+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 cursor-pointer hover:opacity-80 transition-opacity">
                    <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm">
                      <i className="ri-google-fill text-2xl text-[#4285F4]"></i>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-2xl font-bold text-gray-900">4.9</span>
                        <div className="flex items-center gap-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i key={i} className="ri-star-fill text-xl text-amber-400"></i>
                          ))}
                        </div>
                      </div>
                      <p className="text-gray-500 text-sm">209 {currentLang === 'pt' ? 'avaliações' : 'reviews'}</p>
                    </div>
                    <i className="ri-external-link-line text-gray-400 ml-auto"></i>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <form onSubmit={handleSubmit} className="bg-blue-50 rounded-2xl p-8 shadow-lg border border-blue-100" data-readdy-form id="contato-form">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">{t('contact.form.title')}</h3>
                <div className="space-y-5">
                  <div>
                    <label htmlFor="nome" className="block text-gray-700 font-medium mb-2">{t('contact.form.name')} *</label>
                    <input type="text" id="nome" name="nome" value={formData.nome} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder={t('contact.form.namePlaceholder')} />
                  </div>
                  <div>
                    <label htmlFor="telefone" className="block text-gray-700 font-medium mb-2">{t('contact.form.phone')} *</label>
                    <input type="tel" id="telefone" name="telefone" value={formData.telefone} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder="+1 (415) 555-1234 / +55 (11) 99999-9999" />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">{t('contact.form.email')} *</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder={t('contact.form.emailPlaceholder')} />
                  </div>
                  <div>
                    <label htmlFor="motivo" className="block text-gray-700 font-medium mb-2">{t('contact.form.reason')}</label>
                    <select id="motivo" name="motivo" value={formData.motivo} onChange={handleInputChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors cursor-pointer text-sm">
                      <option value="">{t('contact.form.reasonPlaceholder')}</option>
                      <option value="Tax Return">Tax Return (Individual/Family)</option>
                      <option value="Tax Extension">Tax Extension</option>
                      <option value="ITIN">ITIN - {currentLang === 'pt' ? 'Solicitação/Renovação' : 'Application/Renewal'}</option>
                      <option value="Abertura de Empresa">{currentLang === 'pt' ? 'Abertura de Empresa' : 'Company Formation'} (LLC/S Corp)</option>
                      <option value="Bookkeeping">{currentLang === 'pt' ? 'Contabilidade Mensal' : 'Monthly Bookkeeping'}</option>
                      <option value="Payroll">Payroll</option>
                      <option value="Consultoria">{currentLang === 'pt' ? 'Consultoria Fiscal' : 'Tax Consulting'}</option>
                      <option value="Outro">{currentLang === 'pt' ? 'Outro' : 'Other'}</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="mensagem" className="block text-gray-700 font-medium mb-2">{t('contact.form.message')} *</label>
                    <textarea id="mensagem" name="mensagem" value={formData.mensagem} onChange={handleInputChange} required maxLength={500} rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors resize-none text-sm" placeholder={t('contact.form.messagePlaceholder')}></textarea>
                    <p className="text-sm text-gray-500 mt-1">{formData.mensagem.length}/500 {t('contact.form.characters')}</p>
                  </div>
                  <button type="submit" disabled={formStatus === 'sending'} className="w-full bg-blue-600 text-white py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 hover:scale-105 transition-all shadow-md whitespace-nowrap cursor-pointer">
                    {formStatus === 'sending' ? t('contact.form.sending') : t('contact.form.submit')}
                  </button>
                  {formStatus === 'success' && (
                    <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">{t('contact.form.success')}</div>
                  )}
                  {formStatus === 'error' && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">{t('contact.form.error')}</div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Certificações ===== */}
      <section id="certificacoes" className="py-20 px-6 bg-gradient-to-b from-blue-50 to-white">
        <div className="container mx-auto">
          <div className="text-center mb-14">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 text-sm font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-shield-check-line text-lg"></i>
              {t('certifications.badge')}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t('certifications.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('certifications.description')}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="bg-white rounded-2xl border border-blue-100 shadow-lg p-8 hover:shadow-xl hover:-translate-y-1 transition-all">
              <div className="w-full h-20 flex items-center justify-center mb-6">
                <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/8856644ac1362e15f370377e5396c011.png" alt="Enrolled Agent" className="max-w-full max-h-full object-contain" />
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('certifications.ea.title')}</h4>
              <div className="w-10 h-0.5 bg-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 text-sm leading-relaxed">{t('certifications.ea.desc')}</p>
              <span className="inline-block mt-4 bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full">{t('certifications.ea.issuer')}</span>
            </div>
            <div className="bg-white rounded-2xl border border-blue-100 shadow-lg p-8 hover:shadow-xl hover:-translate-y-1 transition-all">
              <div className="w-full h-20 flex items-center justify-center mb-6">
                <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/b89f0724401a5af839de6c6a96a86730.png" alt="IRS Authorized e-file Provider" className="max-w-full max-h-full object-contain" />
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('certifications.efile.title')}</h4>
              <div className="w-10 h-0.5 bg-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 text-sm leading-relaxed">{t('certifications.efile.desc')}</p>
              <span className="inline-block mt-4 bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full">{t('certifications.efile.issuer')}</span>
            </div>
            <div className="bg-white rounded-2xl border border-blue-100 shadow-lg p-8 hover:shadow-xl hover:-translate-y-1 transition-all">
              <div className="w-full h-20 flex items-center justify-center mb-6">
                <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/eea386aa7c1d34addd922fe9dbed0377.png" alt="IRS Certified Acceptance Agent" className="max-w-full max-h-full object-contain" />
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('certifications.acceptance.title')}</h4>
              <div className="w-10 h-0.5 bg-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 text-sm leading-relaxed">{t('certifications.acceptance.desc')}</p>
              <span className="inline-block mt-4 bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full">{t('certifications.acceptance.issuer')}</span>
            </div>
            <div className="bg-white rounded-2xl border border-blue-100 shadow-lg p-8 hover:shadow-xl hover:-translate-y-1 transition-all">
              <div className="w-full h-20 flex items-center justify-center mb-6">
                <img src="https://static.readdy.ai/image/0e4a9c2d00ce897da69d164242b1c444/c636a471f473202f4389ed176e80004f.png" alt="CTEC California" className="max-w-full max-h-full object-contain" />
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('certifications.ctec.title')}</h4>
              <div className="w-10 h-0.5 bg-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 text-sm leading-relaxed">{t('certifications.ctec.desc')}</p>
              <span className="inline-block mt-4 bg-blue-50 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full">{t('certifications.ctec.issuer')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Footer ===== */}
      <footer className="bg-blue-950 text-white py-16 px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <h3 className="text-2xl font-bold mb-4">Amiraco Tax Service</h3>
              <p className="text-white/80 text-sm leading-relaxed mb-4">{t('footer.description')}</p>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-google-fill text-[#4285F4]"></i>
                <span className="text-white/80">4.9</span>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
                <span className="text-white/60">(209)</span>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">{t('footer.navigation')}</h4>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('inicio')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.home')}</button></li>
                <li><button onClick={() => scrollToSection('especialidades')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.specialties')}</button></li>
                <li><button onClick={() => scrollToSection('sobre')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.about')}</button></li>
                <li><button onClick={() => scrollToSection('time')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.team')}</button></li>
                <li><button onClick={() => scrollToSection('certificacoes')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{currentLang === 'pt' ? 'Certificações' : 'Certifications'}</button></li>
                <li><button onClick={() => scrollToSection('blog')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.blog')}</button></li>
                <li><button onClick={() => scrollToSection('contato')} className="text-white/80 hover:text-white transition-colors cursor-pointer">{t('nav.contact')}</button></li>
                <li><Link to="/privacy-policy" className="text-white/80 hover:text-white transition-colors cursor-pointer">{currentLang === 'pt' ? 'Política de Privacidade' : 'Privacy Policy'}</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">{t('footer.mainServices')}</h4>
              <ul className="space-y-2 text-sm">
                <li className="text-white/80">Tax Return (Individual/Family)</li>
                <li className="text-white/80">ITIN - {currentLang === 'pt' ? 'Solicitação e Renovação' : 'Application and Renewal'}</li>
                <li className="text-white/80">{currentLang === 'pt' ? 'Abertura de Empresa' : 'Company Formation'} (LLC/S Corp)</li>
                <li className="text-white/80">Bookkeeping & Payroll</li>
                <li className="text-white/80">{currentLang === 'pt' ? 'Consultoria Fiscal' : 'Tax Consulting'}</li>
                <li className="text-white/80">Notary Public</li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">{t('footer.quickContact')}</h4>
              <ul className="space-y-3 text-sm">
                <li><a href="tel:+14153353243" className="text-white/80 hover:text-white transition-colors cursor-pointer">+1 (415) 335-3243</a></li>
                <li><a href="mailto:info@amiraco.com" className="text-white/80 hover:text-white transition-colors cursor-pointer">info@amiraco.com</a></li>
                <li className="text-white/60 text-xs pt-2">2644 Appian Way, Suite 205<br />Pinole, CA 94564</li>
              </ul>
              <div className="flex gap-4 mt-6">
                <a href="https://www.facebook.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer"><i className="ri-facebook-fill text-xl"></i></a>
                <a href="https://www.instagram.com/amiracotaxservice" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer"><i className="ri-instagram-line text-xl"></i></a>
              </div>
            </div>
          </div>
          <div className="border-t border-white/20 pt-8 text-center">
            <p className="text-white/60 text-sm">
              {t('footer.copyright')} | <Link to="/privacy-policy" className="hover:text-white transition-colors cursor-pointer">{currentLang === 'pt' ? 'Política de Privacidade' : 'Privacy Policy'}</Link> | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* CTA Flutuante Mobile */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-blue-600 shadow-2xl flex">
        <a href="tel:+14153353243" className="flex-1 bg-blue-700 text-white py-4 flex items-center justify-center gap-2 font-semibold cursor-pointer">
          <i className="ri-phone-line text-xl"></i>
          {t('mobile.call')}
        </a>
        <a href="https://wa.me/14153353243" target="_blank" rel="noopener noreferrer" className="flex-1 bg-green-500 text-white py-4 flex items-center justify-center gap-2 font-semibold cursor-pointer">
          <i className="ri-whatsapp-line text-xl text-green-400"></i>
          WhatsApp
        </a>
      </div>
    </div>
  );
}
